import React, { useEffect, useState } from "react";
import axios from "axios";
import SEO from "../Components/SEO";
function Catalog() {

    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");

    const loadItems = async () => {
        try {
            const res = await axios.get("http://localhost:5000/api/katalog");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        loadItems();
    }, []);

    const filteredItems = items.filter((item) =>
        item.Naslov.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <SEO 
                title="Katalog | ALU i PVC stolarija JODUST"
                description="Pogledajte naš katalog ALU i PVC stolarije. Prozori, vrata, klizni sistemi, fasadni sistemi. Sve vrste stolarije po meri, kvalitetni profili, moderni dizajn."
                keywords="katalog stolarije, ALU prozori katalog, PVC vrata katalog, klizni sistemi, stolarija Leskovac, stolarija Lebane"
            />
        <main>

            {/* HERO */}
            <section
                className="text-white text-center py-5"
                style={{ backgroundColor: "#1f4068" }}
            >
                <div className="container py-5">
                    <h1 className="display-5 fw-bold">Naš katalog proizvoda</h1>
                    <p className="lead mt-3">
                        Pregledajte proizvode i projekte JODUST – PVC i ALU stolarija, roletne, komarnici i ograde.
                    </p>
                </div>
            </section>

            {/* CATALOG */}
            <section className="py-5 bg-light">
                <div className="container">

                    <h2 className="text-center fw-bold mb-5">
                        Proizvodi i usluge
                    </h2>

                    {/* SEARCH */}
                    <div className="mb-4">
                        <input
                            type="text"
                            placeholder="Pretraži katalog..."
                            className="form-control w-25"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    {/* GRID */}
                    <div className="row">

                        {filteredItems.map((item) => (

                            <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={item.ItemID}>
                                <div className="card h-100 shadow-sm">

                                    <img
                                        src={`http://localhost:5000${item.Image}`}
                                        className="card-img-top"
                                        alt={item.Naslov}
                                        style={{
                                            //height: "180px",
                                            width: "100%",
                                            aspectRatio: "1 / 1",
                                            objectFit: "cover"
                                        }}
                                    />

                                    <div className="card-body p-3">

                                        <h6 className="card-title fw-bold">
                                            {item.Naslov}
                                        </h6>

                                        <p className="card-text small">
                                            {item.opis}
                                        </p>

                                    </div>

                                </div>
                            </div>

                        ))}

                    </div>

                    {filteredItems.length === 0 && (
                        <p className="text-center mt-4">
                            Nema rezultata pretrage
                        </p>
                    )}

                </div>
            </section>

            {/* CTA */}
            <section
                className="text-white text-center py-5"
                style={{ backgroundColor: "#1f4068" }}
            >
                <div className="container">

                    <h2 className="fw-bold">
                        Zainteresovani ste?
                    </h2>

                    <p className="lead mt-3">
                        Kontaktirajte nas za detaljnije informacije o proizvodima i projektima.
                    </p>

                    <a href="/contact" className="btn btn-warning btn-lg mt-3">
                        Kontaktirajte nas
                    </a>

                </div>
            </section>

        </main>
        </>
    );
}

export default Catalog;